<template>
  <div>
    <div class="header_box">
      <el-row class="header container">
        <el-col :xs="4" :sm="3" :md="3" :lg="3" :xl="3" class="header-nav">
          <div class="header-logo" @click="toLink">
            <img
              src="https://oss.chinadentalshow.com/resource/image/pc/3f29fcb2c5e9227b0705c0df032dbc45.png"
              alt=""
            />
          </div>
        </el-col>
        <el-col :xs="4" :sm="20" :md="20" :lg="20" :xl="20" class="navcenter">
          <navMenu @changjqqd="changjqqd"></navMenu>
        </el-col>
        <el-col :xs="8" :sm="2" :md="2" :lg="2" :xl="2">
          <div class="header-right">
            <div class="languagewrap" @click="changeLang">
              <img
                class="right-icon"
                :src="require('../assets/imgs/icon01.png')"
                alt=""
              />
              <span class="showLang">{{
                value == "中文" ? "ENG" : "中文"
              }}</span>
              <el-select
                v-model="value"
                placeholder="Language"
                @change="changeLang"
                popper-class="dropdown_sel"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="mobile-header-box">
      <el-row class="mobile-header">
        <el-col :xs="19" :sm="14">
          <div class="header-logo" @click="toLink">
            <img :src="logo_cds" alt="" />
          </div>
        </el-col>
        <el-col :xs="2" :sm="2">
          <div
            class="header-lang"
            @click="changeLang(value == '中文' ? 'ENG' : '中文')"
          >
            <img v-if="value == '中文'" src="../assets/cn_menu.png" alt="" />
            <img v-else src="../assets/entb.png" alt="" />
          </div>
        </el-col>
        <el-col :xs="2" :sm="2">
          <div class="header-menu">
            <img
              v-if="isShowMenu"
              @click="showMenu"
              src="../assets/imgs/menu_icon.png"
              alt=""
            />
            <i v-else @click="closeMenu" class="el-icon-close"></i>
          </div>
        </el-col>
        <!-- <el-col :xs="5" :sm="3">
          <div class="mobile-header-right">
            <div class="language">
              <p :class="[langcur == 0 ? 'act' : '']" @click="changeMLang(0)">
                中文
              </p>
              <p :class="[langcur == 1 ? 'act' : '']" @click="changeMLang(1)">
                ENG
              </p>
            </div>
          </div>
        </el-col> -->
      </el-row>
      <moblienavMenu v-if="!isShowMenu" @closeMenu="closeMenu"></moblienavMenu>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      class="dialog"
      :visible.sync="dialogVisible"
    >
      <img class="dialog_img" src="../assets/jqqd.jpg" />
      <div class="dialog_txt">
        {{ showtype == 0 ? "Stay Tuned" : "敬请期待" }}
      </div>
    </el-dialog>
  </div>
</template>
  
<script>
import navMenu from "../components/navMenu.vue";
import moblienavMenu from "../components/moblienavMenu.vue";
import { getWebsiteBase } from "@/api/api";
export default {
  components: {
    navMenu,
    moblienavMenu,
  },
  data() {
    return {
      dialogVisible: false,
      isLogin: true,
      langcur: 0,
      memberid: 0,
      options: [
        {
          value: "中文",
          label: "中文",
        },
        {
          value: "ENG",
          label: "ENG",
        },
      ],
      value: "",
      newLang: "中文",
      isShowMenu: true,
      userInfo: {
        nickname: "",
      },
      showtype: "",
      logo: require("../assets/logo.png"),
      logo_cds: require("../assets/logo_cds.png"),
      logoH5: require("../assets/imgs/logo_w.jpg"),
    };
  },
  mounted() {
    this.memberid = localStorage.getItem("memberid");
    this.uuid = localStorage.getItem("uuid");
    this.loggedIn();
    // 设置语言
    this.langSet = this.$language;
    if (this.langSet == "cn") {
      this.value = "中文";
      this.newLang = "ENG";
    } else {
      this.value = "ENG";
      this.newLang = "中文";
    }
    if (this.langSet == "cn") {
      this.langcur = 0;
    } else {
      this.langcur = 1;
    }
    // this.getData();
    //25.6.9 获取网站基本信息 dxm
    this.getWebsite();
  },
  created() {},
  methods: {
    changebtn() {
      this.showtype = 0;
      this.dialogVisible = true;
    },
    changjqqd() {
      this.showtype = 1;
      this.dialogVisible = true;
    },
    login() {
      this.$router.push({
        name: "login",
      });
    },
    changeMLang(index) {
      if (index == 0) {
        this.langcur = index;
        this.$i18n.locale = "cn";
        location.reload();
      } else {
        this.this.showtype = 0;
        this.dialogVisible = true;
      }
    },
    showMenu() {
      this.isShowMenu = false;
    },
    closeMenu() {
      this.isShowMenu = true;
    },
    getWebsite() {
      getWebsiteBase()
        .then((res) => {
          if (res.code == 1) {
            let metaData = {
              title: res.data.shop_name,
              keywords: res.data.pc_keywords,
              desc: res.data.pc_desc,
            };
            localStorage.setItem("metaData", JSON.stringify(metaData));
            this.logo = res.data.shop_logo;
            this.logoH5 = res.data.h5_favicon;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getData() {
      let data = this.$qs.stringify({
        memberid: this.memberid,
        uuid: this.$uuid,
      });
      getUser(data)
        .then((res) => {
          console.log(res);
          if (res.data.errno == 0) {
            this.userInfo = res.data.rst;
            let improve = localStorage.getItem("improve");
            if (
              !this.userInfo.nickname ||
              !this.userInfo.country ||
              !this.userInfo.nickname ||
              !this.userInfo.nickname ||
              this.userInfo.nickname == "请填写姓名" ||
              this.userInfo.nickname == "请填写手机号" ||
              this.userInfo.nickname == "请填写公司名称" ||
              this.userInfo.country == "请填写国家"
            ) {
              console.log(improve, "aaa");
              localStorage.setItem("improve", true);
            } else {
              console.log(improve, "bbb");
              localStorage.setItem("improve", false);
              console.log(improve, "ccc");
              if (improve == null) {
                console.log("zzz");
                this.$router.push({ path: "/pair" });
              } else if (improve && improve !== "false") {
                console.log("xxx");
                this.$router.push({ path: "/pair" });
              }
            }
          } else {
            if (localStorage.getItem("Flag")) {
              localStorage.removeItem("Flag");
              location.reload();
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    changeLang(e) {
      if (this.$language == "cn") {
        // 中文设置
        if (e == "ENG") {
          window.open("https://www.chinadentalshow.com/en/", "_blank");
          this.value = "中文";
          this.newLang = "ENG";
          return false;
        } else {
          this.$router.push({
            path: "/",
          });
          location.reload();
          return false;
        }
      } else if (this.$language == "en") {
        // 英文设置
        if (e == "中文") {
          window.open("https://www.chinadentalshow.com/", "_blank");
          this.value = "ENG";
          this.newLang = "中文";
          return false;
        } else {
          this.$router.push({
            path: "/",
          });
          location.reload();
          return false;
        }
      }
    },
    toLink() {
      this.$router.push({
        path: "/",
      });
    },
    loggedIn() {
      this.memberid = localStorage.getItem("memberid");
      if (this.memberid == 0 || this.memberid == null) {
        this.isLogin = true;
      } else {
        this.isLogin = false;
      }
    },
  },
};
</script>

<style lang="scss" >
.dialog {
  width: 350px;
  height: 288px;
  background: #ffffff;
  border-radius: 12px;
  margin: auto;
  display: flex;
}
.dialog_img {
  width: 151px;
  height: 160px;
}
.dialog_txt {
  margin-top: 40px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 18px;
  color: #333333;
}
.mobile-header-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 10;
}
.header_box_slide {
  width: 100%;
  background: #f9f9f9;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);
  opacity: 0.9;
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 99;
}
.header_slide {
  width: 1280px;
  height: 98px;
  margin: 0 auto;
  padding: 0 70px 0 100px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
.header_box {
  width: 100%;
  background: rgba(0, 22, 48, 0.2);
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 99;
  font-weight: 500;
  backdrop-filter: blur(4px);
}
.header {
  // width: auto;
  height: 88px;
  margin: 0 auto;
  display: flex;
  align-items: center;
}
.header-logo {
  width: 100%;
  height: auto;
  cursor: pointer;
}
.header-logo img {
  width: 100%;
  height: 100%;
}
.header-right {
  width: 100%;
  font-size: 18px;
  color: #fff;
  text-align: center;
  cursor: pointer;
  display: flex;
  align-items: center;
  .right-icon {
    width: 18px;
    height: 18px;
  }
  .lang {
    background: #cac28a;
    border-radius: 30px;
    width: 46%;
    display: flex;
    height: 38px;
    line-height: 30px;
    padding: 5px 10px;
    box-sizing: border-box;
    p {
      width: 50%;
      border-radius: 30px;
      .cur {
        background: #fff;
        color: #cac28a;
      }
    }
  }
}

.el-col {
  border-radius: 0 !important;
}
.navcenter.el-col {
  min-height: 0;
  height: 100%;
}
.languagewrap {
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e62344;
  cursor: pointer;
  height: 40px;
  border-radius: 5px;
  color: #fff;
  .right-icon {
    width: 18px;
    height: 18px;
  }
}
.languagewrap .el-select .el-input__inner {
  height: 38px;
  border: 0 none;
  background-color: #9b8b1c;
  color: #ffffff;
  padding: 0 10px;
  border-radius: 7px;
  margin-top: 0;
  visibility: hidden;
}
.languagewrap .el-select {
  position: absolute;
}
.languagewrap .el-select .el-input .el-select__caret {
  color: #fff;
}
.languagewrap .el-input__suffix {
  display: none;
}

.dropdown {
  background-color: rgba($color: #000000, $alpha: 0.8);
  border: 1px solid rgba($color: #000000, $alpha: 0.8);
  color: #333;
  font-size: 14px;
  padding: 8px 12px;
}

.dropdown {
  border-color: rgba($color: #000000, $alpha: 0.8);

  background-color: rgba($color: #000000, $alpha: 0.8);
  box-sizing: border-box;
  z-index: 99999;

  .el-select-dropdown__item {
    color: rgba($color: #ffffff, $alpha: 0.8);
  }
  .el-popper .popper__arrow {
    border-bottom-color: rgba($color: #000000, $alpha: 0.8);
  }
  .el-popper .popper__arrow::after {
    border-bottom-color: rgba($color: #000000, $alpha: 0.8);
  }

  .el-select-dropdown__item.hover,
  .el-select-dropdown__item:hover {
    color: #fff;
    background-color: rgba($color: #000000, $alpha: 0.8);
  }
  .el-select-dropdown__item.selected {
    color: #fff;
  }
  .popper__arrow {
    border-bottom-color: rgba($color: #000000, $alpha: 0.8) !important;
  }
  .popper__arrow::after {
    border-bottom-color: rgba($color: #000000, $alpha: 0.8) !important;
  }
}

.dropdown_sel {
  background-color: #f4f4f4;
  box-shadow: 0px 0px 4px 0px rgba(255, 255, 255, 0.12);
  border: 1px solid #f4f4f4;
  color: #2c2c2e;
  font-size: 14px;
  padding: 8px 0;
}

.dropdown_sel {
  background-color: #f4f4f4;
  box-shadow: 0px 0px 4px 0px rgba(255, 255, 255, 0.12);
  box-sizing: border-box;
  z-index: 99999;

  .el-select-dropdown__item {
    color: #2c2c2e;
  }
  .el-popper .popper__arrow {
    border-bottom-color: #f4f4f4;
  }
  .el-popper .popper__arrow::after {
    border-bottom-color: #f4f4f4;
  }

  .el-select-dropdown__item.hover,
  .el-select-dropdown__item:hover {
    color: #e62344;
  }
  .el-select-dropdown__item.selected {
    color: #e62344;
  }
  .popper__arrow {
    border-bottom-color: #f4f4f4 !important;
  }
  .popper__arrow::after {
    border-bottom-color: #f4f4f4 !important;
  }
}

.showLang {
  // position: absolute;
  // top: 9px;
  // left: 10px;
  font-weight: 600;
  margin-left: 8px;
}

.mobile-header {
  display: none;
}
@media only screen and (max-width: 767px) {
  .header {
    display: none;
  }
  .header_box_slide {
    display: none;
  }
  .mobile-header {
    color: #fff;
    display: block;
    height: 1.15rem;
    text-align: center;
    line-height: 1.15rem;
    background: #e62344;
    display: flex;
    align-items: center;
    .header-logo {
      width: 2.03rem;
      height: 0.77rem;
      margin-left: 0.29rem;
      img {
        object-fit: contain;
      }
    }
    .header-lang {
      width: 0.5rem;
      height: 0.5rem;
      // position: relative;
      // top: 2px;
      background: #e62344;
      img {
        width: 100%;
        height: auto;
      }
    }
    .header-menu {
      img {
        width: 0.46rem;
        height: 0.46rem;
      }
      i {
        font-size: 26px;
        position: relative;
        top: 5px;
        right: -4px;
      }
    }
    .mobile-header-right {
      display: flex;
      height: 0.88rem;
      align-items: center;
      padding-right: 0.2rem;
      justify-content: space-between;
      display: none;
      .language {
        width: 1.6rem;
        height: 0.48rem;
        display: flex;
        line-height: 0.4rem;
        background: #666;
        border-radius: 24px;
        padding: 0.05rem;
        box-sizing: border-box;
        z-index: 99;
        p {
          flex: 1;
          font-size: 12px;
          height: 100%;
          text-align: center;
        }
        .act {
          color: #000;
          background: #fff;
          border-radius: 14px;
        }
      }
    }
  }
}
</style>
